import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  calculateTimeDifference,
  getWelfareCheckInterval,
} from '../../../../../global.variable';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { UsersService } from '../../users/users.service';

@Component({
  selector: 'gtapp-user-welfare',
  templateUrl: './user-welfare.component.html',
  styleUrl: './user-welfare.component.scss',
  standalone: false,
})
export class UserWelfareComponent implements OnInit, OnDestroy {
  intervalCheck: any;

  // list welfare check params
  welfareCheckConfiguredUserRows: number = 20;
  welfareCheckConfiguredUserPrevious: number = 0;
  welfareCheckConfiguredUserPageNum: number = 1;
  welfareCheckConfiguredUserTotalPages: number = 0;
  welfareCheckConfiguredUserTotalCount: number = 0;
  welfareCheckConfiguredUserTotalCountBackup: number = 0;
  configuredWelfareCheckListData: any = [];

  assigneeSearchList: any = [];

  configuredWelfareCheckTableDetails = [
    {
      header: 'Guard',
      name: 'full_name',
      searchKey: 'full_name',
      sortKey: 'full_name',
    },
    {
      header: 'Guard',
      name: 'full_name',
    },
    {
      header: 'Idle Time',
      name: 'interval_check',
    },
  ];
  setTime(date: Date, time: string) {
    const [hours, minutes] = time?.split(':');
    date.setHours(parseInt(hours), parseInt(minutes), 0);
    return date;
  }
  searchParamsWelfareCheckConfiguured: any;
  sortKeysWelfareCheckConfiguured: any = ['full_name'];

  dialogRef: any;

  webSocketSubscription: any;

  userJobWelfareCheckConfiguredData: any = {};
  constructor(
    private router: Router,
    private spinnerService: LoadingSpinnerService,
    private userService: UsersService,
    private toasterService: ToasterService,
    private webSocketService: WebSocketService,
  ) {}
  ngOnInit(): void {
    this.spinnerService.show();
    this.getUserWelfareChecksConfiguredData();
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        if (
          [
            'wsn_user_clock_out',
            'wsn_user_clock_in',
            'wsn_welfare_interval_changed',
          ].includes(event?.event)
        ) {
          // this.spinnerService.show();
          setTimeout(() => {
            this.getUserWelfareChecksConfiguredData();
          }, 200);
        }
      });
  }
  ngOnDestroy(): void {
    if (this.webSocketSubscription) this.webSocketSubscription?.unsubscribe();
  }
  getUserWelfareChecksConfiguredData(params: any = {}) {
    if (this.welfareCheckConfiguredUserRows) {
      params['rows'] = this.welfareCheckConfiguredUserRows;
    }
    if (this.welfareCheckConfiguredUserPrevious) {
      params['previous'] = this.welfareCheckConfiguredUserPrevious;
    }
    if (this.sortKeysWelfareCheckConfiguured) {
      params.sort_key = this.sortKeysWelfareCheckConfiguured;
    }

    this.userService
      .getCOnfiguredUserWelfareCheck(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.configuredWelfareCheckListData = response?.data;
          this.userJobWelfareCheckConfiguredData =
            response?.other_welfare_check_dict;
          this.configuredWelfareCheckListData?.forEach((user: any) => {
            this.updateUserInterValData(user);
          });

          this.welfareCheckConfiguredUserTotalCount = response['total_size'];

          this.welfareCheckConfiguredUserTotalCountBackup = Math.max(
            this.welfareCheckConfiguredUserTotalCount,
            this.welfareCheckConfiguredUserTotalCountBackup,
          );

          this.welfareCheckConfiguredUserTotalPages = Math.ceil(
            this.welfareCheckConfiguredUserTotalCount /
              this.welfareCheckConfiguredUserRows,
          );
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
        this.spinnerService.hide();
      });
  }

  searchAssignee(event: any) {
    const searchStr = event.target.value;
    if (searchStr?.length == 0) {
      this.spinnerService.show();
      this.getUserWelfareChecksConfiguredData();
    } else if (event.target.value?.length > 2) {
      this.getUserWelfareChecksConfiguredData({
        search_name: searchStr,
      });
    }
  }
  onChangePaginatioWelfareChecksConfigured(event: any) {
    this.welfareCheckConfiguredUserPrevious = event.previous;
    this.welfareCheckConfiguredUserPageNum = event.pageNum;
    this.welfareCheckConfiguredUserRows = event.pageSize;
    this.getUserWelfareChecksConfiguredData();
  }

  sortColumWelfareChecksConfigured(sortData: any) {
    this.resetPageWelfareChecksConfigured();
    this.sortKeysWelfareCheckConfiguured = sortData?.sortList || [];
    this.getUserWelfareChecksConfiguredData();
  }

  searchColumWelfareChecksConfigured(searchData: any) {
    this.resetPageWelfareChecksConfigured();

    this.searchParamsWelfareCheckConfiguured = searchData?.searchParams || {};

    this.getUserWelfareChecksConfiguredData();
  }
  resetPageWelfareChecksConfigured() {
    this.welfareCheckConfiguredUserTotalCount = 0;
    this.welfareCheckConfiguredUserPrevious = 0;
    this.welfareCheckConfiguredUserRows = 10;
    this.welfareCheckConfiguredUserPageNum = 1;
    this.welfareCheckConfiguredUserTotalPages = 0;
  }
  pad(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }
  getIntervalData(user: any) {
    let diffValue = calculateTimeDifference({
      start_day: new Date(),
      end_day: new Date(),
      end_time: user?.end_time,
      start_time: user?.start_time,
    });

    if (diffValue) {
      let seconds = Math.floor(diffValue * 60);
      let hours = Math.floor(seconds / 3600);
      let minutes = Math.floor((seconds % 3600) / 60);
      user.scheduleDuration = `${this.pad(hours)}:${this.pad(minutes)}`;
    } else {
      user.scheduleDuration = '00:00';
    }

    const [intervalData, welfareReminderDict]: any =
      getWelfareCheckInterval(diffValue);
    let newList = intervalData?.slice(1);

    return newList;
  }

  formatTime(event: any, _type: string, user: any) {
    user[_type] = event.target.value;
    user.saveChanges = true;
    const intervalData: any = this.getIntervalData(user);
    user.intervalData = JSON.parse(JSON.stringify(intervalData));
    const maxValue = intervalData[intervalData?.length - 1]?.value;
    user.interval_check = Math.min(maxValue, user?.interval_check || 120);
  }
  updateUserInterValData(user: any) {
    const intervalData: any = this.getIntervalData(user);
    user.intervalData = JSON.parse(JSON.stringify(intervalData));
    const maxValue = intervalData[intervalData?.length - 1]?.value;
    user.interval_check = Math.min(maxValue, user?.interval_check || 120);

    // by default the status as inactive and then find the actual one
    //https://app.shortcut.com/sendem/story/7077/welfare-checks-by-guard#activity-9852
    // {0: inactive, 1: Active, 2:in active (guard not signed in ), 3: Inactive (outside active hours)}
    user.status = 0;
    if (user?.is_active) {
      const startDateTime = this.setTime(new Date(), user?.start_time);
      const endDateTime = this.setTime(new Date(), user?.end_time);
      if (endDateTime < startDateTime) {
        endDateTime.setDate(endDateTime.getDate() + 1);
      }
      const currentDateTime = new Date().getTime();

      if (
        startDateTime.getTime() <= currentDateTime &&
        currentDateTime <= endDateTime.getTime()
      ) {
        user.status = user?.signed_in ? 1 : 2;
      } else {
        user.status = 3;
      }
    }
  }
  intervalChanged(event: any, user: any) {
    user.interval_check = event;
    user.saveChanges = true;
  }
  updateWelfareCheckForUser(user: any, event?: any) {
    let data: any = {
      start_time: user?.start_time,
      end_time: user?.end_time,
      id: user?.id,
      user_id: user?.user_id,
    };
    if (event) {
      // this is a radion btn action
      const welfareOn = event.target.checked;
      data.interval_check = welfareOn ? user?.interval_check : 0;
    } else {
      data.interval_check = user?.interval_check;
    }
    this.userService
      .createUserWelfareCheck(data, {})
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.dialogRef?.close();
          const responseData = response?.data;
          this.userJobWelfareCheckConfiguredData = {
            ...this.userJobWelfareCheckConfiguredData,
            ...response?.other_welfare_check_dict,
          };

          this.configuredWelfareCheckListData =
            this.configuredWelfareCheckListData?.map((user: any) => {
              if (
                user?.id === responseData?.id &&
                user?.user_id === responseData?.user_id
              ) {
                const user = { ...responseData };

                this.updateUserInterValData(user);

                return JSON.parse(JSON.stringify(user));
              }
              return user;
            });
        } else {
          if (event) {
            // this is a radion btn action
            event.target.checked = !event.target.checked;
          }
          user.errorMessage = response['message'];

          setTimeout(() => {
            user.errorMessage = null;
          }, 5000);
          this.toasterService.setMessage({
            errorMessage: response['message'],
            successMessage: '',
          });
        }
      });
  }
}
